import { DateTime } from 'luxon'
import { recordFindRequest, findRequestError } from '../interfaces/findState.ts'
import { authState } from '../store/authState.ts'
import { dataState } from '../store/dataState.ts'
import { setFindInProgress, setFindStatus } from '../store/findState.ts'
import { IDevice, IPet } from '../interfaces/types.ts'
import { post } from './apiHelper.ts'
import { TRACKER_COMMAND_URL } from './urls.ts'

export const findPet = async (pet: IPet) => {
    recordFindRequest(pet)
    const date = DateTime.now().setZone(authState.timezone.value).toLocaleString(DateTime.DATETIME_MED_WITH_WEEKDAY)
    try {
        const devices = dataState.devices
        const device = devices.find(d => d.petId === pet._id)
        const data = {
            iccid: device?.iccid,
            command: 'find',
        }
        setFindInProgress(pet._id, true)
        const result = await post(TRACKER_COMMAND_URL, data)
        if (result?.status === 200) {
            setFindStatus(pet._id, {msg: 'Find command sent to server', date})
            setFindInProgress(pet._id, true)
        } else {
            setFindStatus(pet._id, {msg: 'Find command failed at server', date})
            findRequestError(pet, 'Gibi server error')
            setTimeout(() => {
                setFindStatus(pet._id, {msg:'', date: ''})
                setFindInProgress(pet._id, false)
            }, 1500)
        }
    }
    catch (e) {
        setFindStatus(pet._id, {msg: 'Find command failed at server', date})
        findRequestError(pet, 'Gibi server error')
    }
}

export const findDevice = async (device: IDevice) => {
    if (device) {
        const data = {
            iccid: device?.iccid,
            command: 'find',
        }
        const result = await post(TRACKER_COMMAND_URL, data)
        if (result?.status === 200) {
        } else {
        }
    }
}

export const sendCommand = async (command: string, iccid: string, value: any) => {
    try {
        const data = {
            iccid,
            command,
            value
        }
        const res = await post(TRACKER_COMMAND_URL, data)
        return res && res.status === 200 ? (res.data?.data || true) : false
    }
    catch (e) {
        return false
    }
}
